<div #container>

  <div class="grid-x grid-margin-x">
    <div class="cell">
      <h1 [innerHTML]="'moderat.sanierung.headline' | translate"></h1>
      <div class="grid-x grid-margin-x teaser-wrapper">
        <div class="cell small-12 medium-7 large-9">
          <p [innerHTML]="'moderat.sanierung.teaser.' + path | translate"></p>
        </div>
        <div class="cell small-12 medium-5 large-3">
          @if(forceDialog || showDownload) {
            <dialog-hint clickTarget="nextSteps" textkey="moderat.sanierung.download" [closable]="false" version="button"></dialog-hint>
          }
        </div>
      </div>

      @if (apiErrors.length > 0) {
        <div role="alert" class="form-errors">
          <p [innerHTML]="'moderat.sanierung.error' | translate"></p>
          <ul>
            @for (error of apiErrors; track error) {
              <li [innerHTML]="error | translate: errorPlaceholder()"></li>
            }
          </ul>
        </div>
      }
    </div>
  </div>

  <div #sidebarContainer class="grid-x grid-margin-x result-wrapper">
    <div class="cell small-12 xmedium-5 xmedium-order-2" [style.min-height]="(isPanelOpen && sidebarOffset > 0) ?  sidebarMinHeight + 'px' : 'unset'">
      <aside #sidebar class="medium-fixed-wrapper" [class.fixed]="sidebarOffset > 0" [style.top]="sidebarOffset + 'px'">
        <mat-accordion [multi]="true">
          <mat-expansion-panel [expanded]="true" (click)="onPanelClick()" [class]="'first-panel'">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <h3 [innerHTML]="'moderat.sanierung.saving.headline' | translate"></h3>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <app-sanierung-saving [loading]="loading" [anfrage]="anfrage" [consumption]="consumption"></app-sanierung-saving>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="true" class="show-for-xmedium">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <h3 [innerHTML]="'moderat.sanierung.costs.headline' | translate"></h3>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <app-sanierung-costs-overview [loading]="loading" [costs]="costs" [anfrage]="anfrage" [financing]="financing" (financeDetails)="showFinanceDetails()"></app-sanierung-costs-overview>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="showRecommandSection" (afterCollapse)="showRecommandSection = false" class="show-for-xmedium">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <h3 [innerHTML]="'moderat.sanierung.recommendation.headline' | translate"></h3>
              </mat-panel-title>
            </mat-expansion-panel-header>
            @for(warning of apiWarnings; track warning) {
              <p [innerHTML]="('moderat.sanierung.recommendation.warning.' + warning) | translate"></p>
            }
            <p [innerHTML]="recommendTextkey | translate: recommendPlaceholders"></p>
            @if(showResetButton === true) {
              <button class="button primary" (click)="resetRecommandMeasures()">
                <i class="icon-check"></i><span>{{'moderat.sanierung.recommendation.button' | translate}}</span>
              </button>
            }
          </mat-expansion-panel>
        </mat-accordion>
      </aside>
    </div>

    <div class="cell small-12 xmedium-7 xmedium-order-1">
      <app-sanierung-measures
        [measureData]="measureData"
        [measures]="measures"
        [disableMeasureDistrictHeating]="disableMeasureDistrictHeating"
        [loading]="loading"
        [form]="form"
        [internalPortal]="internalPortal"
        [anfrage]="anfrage"
        (toggleText)="initSidebuttonOffset()"
      ></app-sanierung-measures>
    </div>
  </div>
</div>

<section class="costs-wrapper" id="costs" [formGroup]="financialForm">
  <div class="headline-wrapper">
    <span aria-hidden="true">2.</span>
    <h2 [innerHTML]="'moderat.sanierung.massnahmen.section.costs' | translate"></h2>
  </div>

  @if (costs?.overall?.sum > 0) {
    <div class="grid-x grid-margin-x">
      <div class="cell small-12 xmedium-7 small-order-2 xmedium-order-1">
        <div class="callout light-gray" [innerHTML]="'moderat.sanierung.massnahmen.section.costs.teaser' | translate"></div>
      </div>
      <div class="cell small-12 xmedium-5 small-order-1 xmedium-order-2">
        <app-side-helptext textkey="moderat.sanierung.massnahmen.section.costs.hint" viewPoint="xmedium"></app-side-helptext>
      </div>
    </div>

    <mat-accordion multi>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h3 class="margin" id="finanzierung" [innerHTML]="'moderat.sanierung.massnahmen.section.costs.finanzierung' | translate"></h3>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="grid-x grid-margin-x">
          <div class="cell small-12 xmedium-7 small-order-2 xmedium-order-1">
            <app-sanierung-invest [anfrage]="anfrage" [costs]="costs" [loading]="loading" [costChanges]="costsChanges" [form]="costForm" (onCostChange)="onMeasureSelectionChange(false)"></app-sanierung-invest>
          </div>
          <div class="cell small-12 xmedium-5 small-order-1 xmedium-order-2">
            <app-side-helptext textkey="moderat.sanierung.massnahmen.section.costs.finanzierung.hint" viewPoint="xmedium"></app-side-helptext>
          </div>
        </div>

        @if(extraCreditPossible) {
          <div class="grid-x grid-margin-x margin extra-credit">
            <div class="cell small-12 xmedium-7 small-order-1">
              <h4 class="subsection" [innerHTML]="'moderat.sanierung.massnahmen.section.costs.foerderung' | translate"></h4>
            </div>
            <div class="cell small-12 xmedium-7 small-order-3 xmedium-order-2">
              <div class="callout light-gray callout-kids">
                <strong id="kinder" class="input-group-headline">{{ 'moderat.sanierung.massnahmen.section.costs.foerderung.radio.kinder.label' | translate }}</strong>
                <app-sanierung-help-button [toggles]="toggle" toggleName="kids"></app-sanierung-help-button>
                <mat-radio-group formControlName="kinder" (change)="onKinderChange()">
                  <mat-radio-button name="kinder" value="ja" color="primary">
                    {{ 'moderat.sanierung.massnahmen.section.costs.foerderung.radio.kinder.ja' | translate }}
                  </mat-radio-button>
                  <mat-radio-button name="kinder" value="nein" color="primary">
                    {{ 'moderat.sanierung.massnahmen.section.costs.foerderung.radio.kinder.nein' | translate }}
                  </mat-radio-button>
                </mat-radio-group>
              </div>
              <app-sanierung-help-callout
                [toggles]="toggle"
                toggleName="kids"
                [textkey]="'moderat.sanierung.massnahmen.section.costs.kinder.help.text' | translate"
              ></app-sanierung-help-callout>
              <div class="callout light-gray callout-foerderung">
                <strong id="einkommen'" class="input-group-headline"  >{{ 'moderat.sanierung.massnahmen.section.costs.foerderung.radio.einkommen.label' | translate }}</strong>
                <app-sanierung-help-button [toggles]="toggle" toggleName="funding"></app-sanierung-help-button>
                <mat-radio-group formControlName="einkommen" (change)="onMeasureSelectionChange(false)">
                  @for (income of incomeRange; track income) {
                    <mat-radio-button name="einkommen" [value]="income" color="primary">
                      {{ 'moderat.sanierung.massnahmen.section.costs.foerderung.radio.einkommen.' + income | translate }}
                    </mat-radio-button>
                  }
                </mat-radio-group>
              </div>
              <app-sanierung-help-callout
                [toggles]="toggle"
                toggleName="funding"
                [textkey]="'moderat.sanierung.massnahmen.section.costs.foerderung.help.text' | translate"
              ></app-sanierung-help-callout>
            </div>
            <div class="cell small-12 xmedium-5 small-order-2 xmedium-order-3">
              <app-side-helptext textkey="moderat.sanierung.massnahmen.section.costs.foerderung.hint" viewPoint="xmedium"></app-side-helptext>
            </div>
          </div>
        }


        <app-moderat-sanierung-financing
          [anfrage]="anfrage"
          [financing]="financing"
          [loading]="loading"
          [financialForm]="financialForm"
          (measureSelectionChange)="onMeasureSelectionChange($event)"
          (financingChange)="onFinancingChange($event)"
        ></app-moderat-sanierung-financing>


      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h3 class="margin" [innerHTML]="'moderat.sanierung.massnahmen.section.costs.zukunft' | translate"></h3>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-moderat-sanierung-economy
          [anfrage]="anfrage"
          [financing]="financing"
          [loading]="loading"
        ></app-moderat-sanierung-economy>
        <app-line-chart [anfrage]="anfrage" [loading]="loading"></app-line-chart>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h3 class="margin" [innerHTML]="'moderat.sanierung.wirtschaftlichkeit.vorteile' | translate"></h3>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-sanierung-forecast [anfrage]="anfrage" [loading]="loading"></app-sanierung-forecast>
      </mat-expansion-panel>
    </mat-accordion>
  }
  @else {
  <div class="grid-x grid-margin-x">
    <div class="cell small-12">
      <p class="callout warning" [innerHTML]="'moderat.sanierung.massnahmen.section.costs.nocosts' | translate"></p>
    </div>
  </div>
}

</section>

<section class="grid-container nextsteps-container" #nextStepsContainer>

  <div class="headline-wrapper" id="nextSteps">
    <span aria-hidden="true">3.</span>
    <h2 [innerHTML]="'moderat.sanierung.nextsteps.headline' | translate"></h2>
  </div>

  <div class="grid-x grid-margin-x" >
    <div class="cell small-12">
      @if (forceDialog) {
        <section class="dialog">
          <app-dialogform textkeyPrefix="moderat.naechsteschritte" advisorImagePath="/moc/moc-lead.svg" [registrationData]="dialogData" (onDialogRegister)="dialogRegistered($event)" [downloadUrl]="anfrage?.measureResult?.report"></app-dialogform>
        </section>
      }

      @if (showDownload) {
        <section class="download-wrapper">
          <app-download [url]="anfrage.measureResult.report" textkeyPrefix="moderat.naechsteschritte."></app-download>
        </section>
      }

      @if (showDistrictTeaser) {
        <section class="fernwaerme-wrapper">
          @if (fernwaermenetz === 'ja' || fernwaermenetz === 'perspektivisch') {
            <app-moderat-fernwaerme-teaser
              [showBadge]="true"
              [showLogo]="showDistrictTeaserLogo"
              teaserTopic="beratung"
              teaserClass="callout secondary consultancy"
              buttonClass="inline-arrow-right"
              textkeyPrefix="moderat.sanierung.fernwaerme."
              textkeyPostfix=".ja">
            </app-moderat-fernwaerme-teaser>

            <div class="callout secondary">
              <app-advisor-image [path]="'/moc/portal_logo.svg'" [altText]="'moderat.sanierung.fernwaerme.callout.logo.alttext'| translate"></app-advisor-image>
              <p [innerHTML]="'moderat.sanierung.fernwaerme.description.ja'| translate"></p>
            </div>

            <app-moderat-fernwaerme-teaser
              teaserTopic="brochure"
              teaserClass="brochure"
              imagePath="/gfx/moc/brochure_district_heating.jpg"
              [downloadIcon]="true"
              textkeyPrefix="moderat.sanierung.fernwaerme."
              textkeyPostfix=".ja">
            </app-moderat-fernwaerme-teaser>
          }

          @else {
            <app-moderat-fernwaerme-teaser
              [showBadge]="true"
              [showLogo]="showDistrictTeaserLogo"
              teaserTopic="agency"
              teaserClass="callout secondary agency"
              buttonClass="inline-arrow-right"
              textkeyPrefix="moderat.sanierung.fernwaerme."
              textkeyPostfix=".nein">
            </app-moderat-fernwaerme-teaser>
          }
        </section>
      }

      @if (faqTopics.length > 0) {
        <section class="faq-wrapper">
          <div class="cell small-12">
            <h2 [innerHTML]="'moderat.sanierung.modernisierung.headline' | translate"></h2>
          </div>
          <div class="cell">
            <mat-accordion multi>
              @for (row of faqTopics; track row) {
                <mat-expansion-panel [expanded]="faqTopics.length === 1">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <h3 [innerHTML]="'moderat.sanierung.' + row + '.headline' | translate"></h3>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div [innerHTML]="'moderat.sanierung.' + row + '.text' | translate: {eur: (anfrage?.measureResult?.costs?.financing[financing]?.funding_grants?.sum | number: '1.0-0') }"></div>
                </mat-expansion-panel>
              }
            </mat-accordion>
          </div>
        </section>
      }

      <section class="portal">
        <app-portal-teaser></app-portal-teaser>
      </section>

      @if (internalPortal === true) {
        <section class="donate-wrapper">
          <app-donate textkeyPrefix="moderat"></app-donate>
        </section>
      }
    </div>
  </div>

  <button #sideButton class="button primary scroll-up-button" aria-hidden="true" [class.fixed]="sideButtonOffset > 0" [style.top]="sideButtonOffset + 'px'" (click)="scrollToTop()" [innerHTML]="'moderat.sanierung.back.to.result' | translate"></button>
</section>

<app-step-buttons [previousLink]="previousLink" mediumWidthRight="8" mediumOffset="auto" leftAlignSize="" largeOffset="auto" largeWidthRight="5" previousText="step.button.previous" [nextLink]="this.showResetRequestButton? '../../einstieg' : null" nextText="step.button.newrequest" [nextSubmit]="false" (onNextClick)="resetRequest()"></app-step-buttons>

